<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass">
@import 'component'
</style>

<template>
  <div class="form-group" v-bind:class="$v.model.$error ? 'is-invalid' : 'is-dirty'">
    <vue-select
      v-model="output"
      :value="input"
      :placeholder="'Введите ИНН вашей ООО или ИП'"
      :options="options"
      :filterable="false"
      @search="onSearch"
    >
      <template slot="no-options">
        <span style="font-size: 0.6em; color: rgba(0, 0, 0, 0.6)">
          Введите ИНН или название компании
        </span>
      </template>

      <template slot="option" slot-scope="option">
        <div class="text-left">
          {{ option.data.inn }}
        </div>
        <div class="text-left">
          <small style="font-size: 0.6em">
            {{ option.value }}
          </small>
        </div>
      </template>

      <template slot="selected-option" slot-scope="option">
        <div class="text-center">
          {{ option.data.inn }}
        </div>
        <div class="text-center">
          <small style="font-size: 0.6em">
            {{ option.value }}
          </small>
        </div>
      </template>
    </vue-select>

    <div class="invalid-feedback" v-if="!$v.model.invalid">
      {{ $t('error_inn_is_not_valid') }}
    </div>

    <div class="invalid-feedback" v-if="!$v.model.numeric">
      {{ $t('error_inn_is_not_valid') }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import VueSelect from 'vue-select';
import 'inputmask/dist/inputmask/inputmask.numeric.extensions';
import { numeric } from 'vuelidate/lib/validators';

export default {
  components: {
    VueSelect,
  },

  data() {
    return {
      input: null,
      output: null,
      model: null,
      options: [],
    };
  },

  props: ['value', 'label'],

  mounted() {
    this.model = this.value;

    this.$v.model.$touch();
  },

  validations: {
    model: {
      numeric,
      invalid(value) {
        if (value === '') {
          return true;
        }
        if (value === null) {
          return true;
        }
        return value.length === 10 || value.length === 12;
      },
    },
  },

  watch: {
    output(val, old) {
      if (val && val.data && val.data.inn) {
        this.model = val.data.inn;
        this.$v.model.$touch();
        if (this.$v.model.$error === false) {
          this.$emit('input', val.data.inn);
        }
        this.setVat(val.data.type);
      }

      if (val === null) {
        this.$emit('input', val);
      }
    },
  },

  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
      // setTimeout(() => {
      //   debugger
      // }, 1500)
    },
    setVat(type) {
      if (type === 'LEGAL') {
        this.$emit('set-vat', 'С НДС');
      } else if (type === 'INDIVIDUAL') {
        this.$emit('set-vat', 'Без НДС');
      }
    },

    search: _.debounce((loading, search, vm) => {
      fetch('https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party', {
        method: 'post',
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Token f573c42ef57883238c85ba764d5a703d02b0e956',
        },
        body: JSON.stringify({
          query: search,
        }),
      })
        .then((response) => response.json())
        .then((json) => {
          vm.options = json.suggestions
            .filter((record) => record.data.state.status === 'ACTIVE')
            .map((record) => {
              record.label = record.value;
              return record;
            });
          loading(false);
        });
    }),
  },
};
</script>
